import axiosClient from './axiosClient';

const notificationCampaignApi = {
  getCampaigns: (params) => axiosClient.get('/notification-campaigns', { params }),
  createCampaign: (payload) => axiosClient.post('/notification-campaigns', payload),
  updateCampaign: (id, payload) => axiosClient.put(`/notification-campaigns/${id}`, payload),
  deleteCampaign: (id) => axiosClient.delete(`/notification-campaigns/${id}`),
  activate: (id) => axiosClient.post(`/notification-campaigns/${id}/activate`),
  pause: (id) => axiosClient.post(`/notification-campaigns/${id}/pause`),
  resume: (id) => axiosClient.post(`/notification-campaigns/${id}/resume`),
  // payload = form values (not saved yet) or {} with an id
  previewAudience: (payload) => axiosClient.post('/notification-campaigns/preview', payload),
  sendTest: (payload) => axiosClient.post('/notification-campaigns/test', payload),
  getRuns: (id) => axiosClient.get(`/notification-campaigns/${id}/runs`),
};

export default notificationCampaignApi;
